import { useTranslation } from 'react-i18next';
import { useSearch } from '@tanstack/react-router';
import { buttonVariants } from '@/shared/components/ui/button';

const ERROR_CODES: Record<string, string> = {
  SESSION_EXPIRED: 'checkout.error.sessionExpired',
  HANDOFF_SIGNATURE_INVALID: 'checkout.error.signatureInvalid',
  HANDOFF_TIMESTAMP_EXPIRED: 'checkout.error.timestampExpired',
  RETURN_URL_DOMAIN_NOT_ALLOWED: 'checkout.error.domainNotAllowed',
  PRODUCT_NOT_FOUND: 'checkout.error.productNotFound',
  PLAN_NOT_FOUND: 'checkout.error.planNotFound',
};

export function CheckoutErrorPage() {
  const { t } = useTranslation();
  const search = useSearch({ strict: false }) as { code?: string; returnUrl?: string };
  const errorKey = search.code
    ? (ERROR_CODES[search.code] ?? 'checkout.error.generic')
    : 'checkout.error.generic';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md text-center space-y-6">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <svg
            className="h-8 w-8 text-destructive"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <div>
          <h1 className="text-xl font-semibold text-foreground">{t('checkout.error.title')}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{t(errorKey)}</p>
        </div>

        {search.returnUrl && (
          <a href={search.returnUrl} className={buttonVariants({ variant: 'outline' })}>
            {t('checkout.error.returnToApp')}
          </a>
        )}
      </div>
    </div>
  );
}
